<template>
  <div id="index">
    <!-- <div class="mHeader">
      <img class="mHeaderLeft" src="../../assets/img/mLeft.png" >
      <b>亳药师</b>
      <img class="mHeaderMenu" v-show="showHeaderIcon" src="../../assets/img/mIndexMenu.png" @click="showMenu">
      <img class="mHeaderUser" v-show="showHeaderIcon" src="../../assets/img/mUser.png"  @click="goLogin">
      <img class="mHeaderClose" v-show="showHeaderIcon2" src="../../assets/img/mIndexClose.png" @click="closeMenu" >
    </div>
    <div class="mMenu" v-show="showMenuDiv">
      <ul>
        <li v-for="(item,menuIndex) in menuList" :class="menuActiveClass == menuIndex ? 'menuActive':''" :key="item.name"  @click="goMenu(item.go,menuIndex)">{{item.name}}</li>
      </ul>
    </div> -->
    <mHeader ref="mHeader"></mHeader>
    <div style="width:100%;height:44px"></div>
    <div class="mSearch">
      <input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input2" />
      <img class="mHeaderLeft" src="../../assets/img/mIndexSearch.png" >
      <button  @click="search">搜索</button>
    </div>
    <!-- <div class="mClass">
      <div >
        <b>全部：</b><a v-for="(item,index) in letterList" :key="index" :class="activeClass == index ? 'activeA':''" @click="changeA(index,id)">{{item.name}}</a>
      </div>
    </div> -->

    <ul class="mIndexPro">
      <li v-for="item in goodsList" :key="item.id"  @click="goProductDetails(item.id)">
        <img :src="item.images" />
        <p>{{item.goodName}}&nbsp;{{item.chandi}}</p>
        <p><span>价格电议</span> </p>
      </li>
    </ul>
    <ul class="mfoot">
      <li>皖公网安备 34160202000600号   皖ICP备18026442号</li>
      <li>电话：0558-5858131</li>
      <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
      <li>安徽广盛堂中药饮片有限公司</li>
    </ul>
  </div>
</template>
<script>
import mHeader from '../../components/mobile/mHeader'
export default {
  components: {
    mHeader
  },
  data() {
    return {
      input2:'',
      activeClass:0,
      letterList:[
        {id:"1",name:'A'},
        {id:"2",name:'B'},
        {id:"3",name:'C'},
        {id:"4",name:'D'},
        {id:"5",name:'E'},
        {id:"6",name:'F'},
        {id:"7",name:'G'},
        {id:"8",name:'H'},
        {id:"9",name:'I'},
        {id:"10",name:'J'},
        {id:"11",name:'K'},
        {id:"26",name:'L'},
        {id:"12",name:'M'},
        {id:"13",name:'N'},
        {id:"14",name:'O'},
        {id:"15",name:'P'},
        {id:"16",name:'Q'},
        {id:"17",name:'R'},
        {id:"18",name:'S'},
        {id:"19",name:'T'},
        {id:"20",name:'U'},
        {id:"21",name:'V'},
        {id:"22",name:'W'},
        {id:"23",name:'X'},
        {id:"24",name:'Y'},
        {id:"25",name:'Z'},
      ],
      goodsList:[],
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null || this.$cookie.get('account') == ''){
      this.showLogin = true
      this.showAfterLogin = false
    }else{
      this.showLogin = false
      this.showAfterLogin = true
    }
    this.getGoodsList();
  },
  methods: {
    changeA(index,id){
      this.activeClass = index;
       this.$fetch('getDynamicsList',{market:id}).then(res => {
        this.dynamicsList = res.result.records;
      })
    },
    search(){
      this.$fetch('getSearchList',{goodName:this.input2,pageNo:1,pageSize:10}).then(res => {
        if(res.result.records == []){
          return
        }else{
          this.goodsList = res.result.records
        }
      })
    },
    //产品
    getGoodsList(){
      this.$fetch('getGoodsList',{recommend: 'Y',pageNo:1,pageSize:10}).then(res => {
        this.goodsList = res.result.records;
      })
    },
    //跳转产品详情
    goProductDetails(id){
      this.$router.push({name:'mProductDetails',query: {id:id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/mProductList.vue